import type { FeatureDefinitionGroup, FeatureExtractionVisibility } from '../feature-definition-types';

export type CallsRelativePath = '/call-history' | '/voicemails' | '/call-queue-stats' | '/team-presence';

export const featureDefinition = {
  root: '/calls',
  iconName: 'phone',
  items: {
    '/call-history': {
      label: 'Call History',
      altSearchLabel: 'Recent Calls',
      trackingId: 'nav-calls-recent-calls',
      description: 'A log of inbound and outbound calls, including caller details, call recordings, and timestamps.',
    },
    '/voicemails': {
      label: 'Voicemails',
      trackingId: 'nav-calls-voicemails',
      description: 'Displays recorded voicemail messages. Users can listen, mark as read, tag, or delete messages.',
    },
    '/call-queue-stats': {
      label: 'Call Queue Data',
      trackingId: 'nav-calls-call-queue-data',
      description:
        'Provides call queue metrics like hold times, number of callers in queue, and service performance statistics.',
    },
    '/team-presence': {
      label: 'Team Status',
      altSearchLabel: 'Team Status',
      trackingId: 'nav-calls-team-presence',
      description: 'Monitor user and device presence.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/calls', 'phone', CallsRelativePath>;

export const featureExtractionVisibility = {
  itemShowClassifications: {
    '/team-presence': 'runtime-conditional',
  },
} as const satisfies FeatureExtractionVisibility<CallsRelativePath>;
